import { sel } from "../../academy/selectors";
import { TutorialDefinition } from "../types";

/**
 * Academy lesson: import from Axon Evidence. Started from the lesson page in a
 * new tab; never auto-started. It opens the upload window and points at Add
 * Bodycam Video, then at the Axon list; it never adds a clip or starts a
 * transfer.
 */
const tour: TutorialDefinition = {
  id: "import-from-axon-evidence",
  version: "1.0.0",
  releasedAt: "2026-10-29T00:00:00.000Z",
  category: "onboarding",
  title: "Import from Axon",
  description: "Pull body cam footage from Axon Evidence into a case.",
  triggerRoute: /^\/cases(\/.*)?$/,
  startRoute: "/cases",
  lessonId: "import-from-axon-evidence",
  autoStart: false,
  steps: [
    {
      target: sel("newCaseDropdown"),
      waitFor: sel("newCaseDropdown"),
      title: "Open the upload window",
      content: "Click New Case, then Upload Files.",
      disableBeacon: true,
      placement: "right",
      advanceOn: { selector: sel("newCaseUpload"), event: "click" },
      hint: "Click New Case, then Upload Files to continue",
      spotlightClicks: true,
    },
    {
      target: sel("uploadBodycam"),
      waitFor: sel("uploadBodycam"),
      waitTimeoutMs: 8000,
      title: "Add Bodycam Video",
      content:
        "This button opens your Axon Evidence library. If you don't see it, your admin hasn't connected Axon on the Integrations tab yet.",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: sel("uploadDropzone"),
      waitFor: sel("uploadDropzone"),
      title: "Mix in your own files",
      content:
        "Axon clips and files from your computer can share one case. Local files upload from your browser; Axon clips transfer on the server, so you can leave once the local files finish.",
      disableBeacon: true,
      placement: "bottom",
    },
    {
      target: sel("uploadSubmit"),
      waitFor: sel("uploadSubmit"),
      title: "Upload",
      content:
        "In the library, click a clip, then Add to Upload. Clips over 4 hours are grayed out. When you're ready, this button shows how many files you're sending.",
      disableBeacon: true,
      placement: "top",
    },
  ],
};

export default tour;
